import { Alert } from '../../domain/model/alert';
import Handler from '@/core/domain/usecase/handler';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';


export interface ChangeAlertRepository {
  (id: number, data: object): Promise<Alert>
}

const changeAlertRepository = (axios: AxiosInstance): ChangeAlertRepository => async (id: number, data: object) => {
  try {
    const response: AxiosResponse = await axios.put(`/alert/${id}`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default changeAlertRepository

